module.exports = __webpack_public_path__ + "img/1440.a8a92260.svg";